// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 609 ? "faq" : chunkId) + "-legacy." + {"208":"3f538ab1","532":"e46d6d6e","609":"85090686","752":"25b2d3a5","854":"bd23b07a"}[chunkId] + ".js";
};